<ng-container *transloco="let t">
@if (shouldRenderBanner && !hasUserChoice()) {
	<ion-grid class="w-100 cookie-banner">
		<ion-row>
			<ion-col class="cookie-banner-content">
				{{t("cookie-pop.Nous respectons votre vie privée")}}.
				<span class="text-bold">{{t("cookie-pop.Nous n’utilisons aucun traqueur de publicité !")}}</span>
				{{t("cookie-pop.Nous n'utilisons aucune de vos données, et nous les stockons dans notre base de données dont l'accès est strictement réservé à l'Administration de")}}
				Slaveous.com <br>
				{{
t("cookie-pop.En poursuivant votre navigation, vous acceptez l'utilisation de simples outils de suivi (traceurs, cookies) pour la réalisation de statistiques et de mesures d'audience")}}.
				<ion-nav-link [routerLink]="translateService.localize('/cookies')" routerDirection="root"
				              routerLinkActive="active-link">{{t("cookie-pop.Voir notre")}}&nbsp;<span
					class="cookie-policy-link">{{t("cookie-pop.politique de cookies")}}</span>
				</ion-nav-link>
			</ion-col>
		</ion-row>
		<ion-row class="cookie-actions">
			<ion-button (click)="cookiesConsent()" class="mt-auto mb-auto cookie-action-btn cookie-action-btn--accept" color="medium" expand="full" fill="outline"
			            shape="round">
				{{t("cookie-pop.J’accepte")}}
			</ion-button>
			<ion-button (click)="cookiesReject()" class="mt-auto mb-auto cookie-action-btn cookie-action-btn--reject" color="medium" expand="full" fill="outline"
			            shape="round">
				{{t("cookie-pop.Je refuse")}}
			</ion-button>
		</ion-row>
	</ion-grid>
}

</ng-container>
